import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-textarea-autosize';
import { useMutation } from 'react-apollo';

import withModal from '../../../../../../../../components/global/modal/withModal';
import { photoUpdate } from '../../../../../../../../graphql/mutations/photos';
import Alert from '../../../../../../../../components/global/Alert';
import DismissButton from '../../../../../../../../components/global/DismissButton';
import Button from '../../../../../../../../components/global/Button';
import { PhotoForCaption } from '../../../../../../../../graphql/queries/photos';

export const PHOTO_CAPTION_CAPTURE_MODAL = 'modal/PHOTO_CAPTION_CAPTURE';

const propTypes = {
  photo: PropTypes.shape({
    id: PropTypes.string,
    description: PropTypes.string,
  }),

  onRequestClose: PropTypes.func,
};

const PhotoCaptionCaptureModal = ({ photo, onRequestClose }) => {
  const [photoUpdateMutation] = useMutation(photoUpdate);
  const [loading, setLoading] = useState(false);
  const [caption, setCaption] = useState(photo?.description ?? '');
  const [error, setError] = useState('');
  const captionInput = useRef(null);

  useEffect(() => {
    setCaption(photo?.description ?? '');
    captionInput.current?.focus();
  }, [photo]);

  const onSave = async () => {
    if (loading) {
      return;
    }

    setError('');
    setLoading(true);

    try {
      await photoUpdateMutation({
        variables: {
          input: {
            photo_id: photo?.id,
            description: caption,
          },
        },
        refetchQueries: [
          {
            query: PhotoForCaption,
            variables: {
              id: photo?.id,
            },
          },
        ],
      });

      setCaption('');
      setLoading(false);

      onRequestClose();
    } catch (err) {
      setError(err);
    }
  };

  const onCancel = () => {
    onRequestClose();
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <DismissButton className="text-white" onClick={onRequestClose} />
        <Button
          disabled={loading}
          btnStyle="reset"
          className="text-bold"
          onClick={onSave}
        >
          {loading ? 'Saving...' : 'Save'}
        </Button>
      </div>
      <TextareaAutosize
        placeholder="Start writing a caption..."
        name="caption"
        id="caption"
        value={caption}
        onChange={event => {
          setCaption(event.target.value);
        }}
        onKeyDown={event => {
          if (event.keyCode === 27) {
            // Escape key
            event.stopPropagation();
            event.preventDefault();
            onCancel();
          }
        }}
        minRows={10}
        ref={captionInput}
      />

      {error && (
        <Alert type="danger">
          <p>There was a problem processing your request:</p>
          <p>{error}</p>
        </Alert>
      )}
    </>
  );
};

PhotoCaptionCaptureModal.propTypes = propTypes;

export default withModal(PhotoCaptionCaptureModal, {
  name: PHOTO_CAPTION_CAPTURE_MODAL,
  className: 'photo-caption-modal',
  size: 'sm',
  type: 'full',
  dismissible: false,
});
